import { render, staticRenderFns } from "./ThemeForm.vue?vue&type=template&id=504c0ef6&scoped=true&"
import script from "./ThemeForm.vue?vue&type=script&lang=ts&"
export * from "./ThemeForm.vue?vue&type=script&lang=ts&"
import style0 from "./ThemeForm.vue?vue&type=style&index=0&id=504c0ef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c0ef6",
  null
  
)

export default component.exports